import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this example we will listen to an example of binaural synthesis. Please wear headphones and listen to the speech and music examples. You can click an the white circles to change the direction from the sound. The orange circle is indicating the current position.",
  theory: theory,
  layout: {
    type: "custom031600",
    options: {
      data: {
        "az-135_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-135_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-135_el-45.wav`,
        },
        "az-135_el0": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-135_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-135_el0.wav`,
        },
        "az-135_el45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-135_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-135_el45.wav`,
        },
        "az-180_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-180_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-180_el-45.wav`,
        },
        "az-180_el0": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-180_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-180_el0.wav`,
        },
        "az-180_el45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-180_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-180_el45.wav`,
        },
        "az-45_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-45_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-45_el-45.wav`,
        },
        "az-45_el0": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-45_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-45_el0.wav`,
        },
        "az-45_el45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-45_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-45_el45.wav`,
        },
        "az-90_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-90_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-90_el-45.wav`,
        },
        "az-90_el0": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-90_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-90_el0.wav`,
        },
        "az-90_el45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az-90_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az-90_el45.wav`,
        },
        "az0_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az0_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az0_el-45.wav`,
        },
        "az0_el-90": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az0_el-90.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az0_el-90.wav`,
        },
        az0_el0: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az0_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az0_el0.wav`,
        },
        az0_el45: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az0_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az0_el45.wav`,
        },
        az0_el90: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az0_el90.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az0_el90.wav`,
        },
        "az135_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az135_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az135_el-45.wav`,
        },
        az135_el0: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az135_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az135_el0.wav`,
        },
        az135_el45: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az135_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az135_el45.wav`,
        },
        "az180_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az180_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az180_el-45.wav`,
        },
        az180_el0: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az180_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az180_el0.wav`,
        },
        az180_el45: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az180_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az180_el45.wav`,
        },
        "az45_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az45_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az45_el-45.wav`,
        },
        az45_el0: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az45_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az45_el0.wav`,
        },
        az45_el45: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az45_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az45_el45.wav`,
        },
        "az90_el-45": {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az90_el-45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az90_el-45.wav`,
        },
        az90_el0: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az90_el0.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az90_el0.wav`,
        },
        az90_el45: {
          leftAudioUrl: `${config.ASSETS_URL}/03/16/principle/NewsSpeech_az90_el45.wav`,
          rightAudioUrl: `${config.ASSETS_URL}/03/16/principle/MR0804_JesperBuhlTrio_Full_cut_az90_el45.wav`,
        },
      },
    },
  },
};

export default principle;
